import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavigationBar from './NavigationBar';

class HelpView extends Component {
    
    render() {
        return (
            <div>
                <NavigationBar />
                <div className="panel-group helpDiv" id="accordion" role="tablist" aria-multiselectable="true">
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingOne" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <h4 className="panel-title">
                                        <span>Home Screen</span>
                                    </h4>
                                </div>
                                <div id="collapseOne" className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>Callflow Data Service is a custom web-based application that extends Genesys Cloud functionality. It provides a user friendly interface for managing CSV files. The application lists the CSV files uploaded and provides the option for downloading and deleting the files.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Home.png" alt="Home" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingTwo" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <h4 className="panel-title">
                                        <span>Upload New file</span>
                                    </h4>
                                </div>
                                <div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The Upload button highlighted in the below image, when clicked opens the window for selecting a new file. Select a file – only csv format and click OK.
                                                </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_NewFile.png" alt="Upload_NewFile" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingThree" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <h4 className="panel-title">
                                        <span>Upload InProgress</span>
                                    </h4>
                                </div>
                                <div id="collapseThree" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>
                                                    Once the file is uploaded, the status of the upload will be shows as in the image. After the file is uploaded, the file will be processed. While the files is being processed, the file is not available for download or delete as shown in the image.
                                                </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_InProgress.png" alt="Upload_InProgress" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingFour" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <h4 className="panel-title">
                                        <span>Upload Complete</span>
                                    </h4>
                                </div>
                                <div id="collapseFour" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>Once the upload is complete the file is made available for download and delete and update.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_Complete.png" alt="Upload_Complete" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingFive" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <h4 className="panel-title">
                                        <span>Updating file</span>
                                    </h4>
                                </div>
                                <div id="collapseFive" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFive">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The contents of a uploaded file is updated through the unique update option provided for each files. The contents are updated and the file is uploaded using the corresponding update button provided for the file. The update button is in the same row of the file. </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Update_File.png" alt="Update_NewFile" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingSix" data-toggle="collapse" data-parent="#accordion" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <h4 className="panel-title">
                                        <span>Delete file</span>
                                    </h4>
                                </div>
                                <div id="collapseSix" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSix">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The files uploaded are provided with the option to delete. Only one file can be deleted at a time. Each file is deleted using the delete button in the corresponding row. A prompt shows up asking for the confirmation from user to delete the file. </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Delete_File.png" alt="Delete_File" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingSeven" data-toggle="collapse" data-parent="#accordion" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <h4 className="panel-title">
                                        <span>Download file</span>
                                    </h4>
                                </div>
                                <div id="collapseSeven" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeven">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The file is downloaded by clicking the download icon in the corresponding row.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Download_File.png" alt="Download_File" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingEight" data-toggle="collapse" data-parent="#accordion" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                    <h4 className="panel-title">
                                        <span>Query a record</span>
                                    </h4>
                                </div>
                                <div id="collapseEight" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEight">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The data uploaded in the web application can be queried using the below data action. Following is the structure for the data action to query a data</p>
                                            </div>
                                            <div className="col">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                    <th scope="col">End Point</th>
                                                    <th scope="col">Get Record</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>Purpose</td>
                                                    <td>End point used to get a specific record based on a column name(QueryKey) and column value(QueryValue) of a particular file(fileName) uploaded.</td>
                                                    </tr>
                                                    <tr>
                                                    <td>URL</td>
                                                    <td> <div>protocol://hostname/record?fileName=fileName&QueryKey=QueryKey&QueryValue=QueryValue<br/>

                                                    <label className="strong">Eg: https://2kajbl04jl.execute-api.us-east-1.amazonaws.com/prod/record?fileName=File1.csv&QueryKey=Id&QueryValue=22</label></div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Method</td>
                                                        <td>GET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Required Headers</td>
                                                        <td>env, token, tokensource</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Request Body</td>
                                                        <td>N/A</td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingNine" data-toggle="collapse" data-parent="#accordion" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    <h4 className="panel-title">
                                        <span>Update a record</span>
                                    </h4>
                                </div>
                                <div id="collapseNine" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNine">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The data uploaded in the web application can be updated using the update data action. Following is the structure for the data action to update a record.</p>
                                            </div>
                                            <div className="col">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                    <th scope="col">End Point</th>
                                                    <th scope="col">Update Record</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>Purpose</td>
                                                    <td>End point used to update a specific record based on a column name(QueryKey) and column value(QueryValue) of the a particular file uploaded. The name of the file to which the data is updated is given through query parameter fileName. The data to be updated is given in the request body as JSON.</td>
                                                    </tr>
                                                    <tr>
                                                    <td>URL</td>
                                                    <td> <div>protocol://hostname/record?fileName=fileName&QueryKey=QueryKey&QueryValue=QueryValue<br/>

                                                    <label className="strong">Eg: https://2kajbl04jl.execute-api.us-east-1.amazonaws.com/prod/record?fileName=File1.csv&QueryKey=Id&QueryValue=22</label></div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Method</td>
                                                        <td>PATCH</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Required Headers</td>
                                                        <td>content-type, env, token, tokensource</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Request Body example</td>
                                                        <td>&#123; "name": "sean","title": "Esquire","fish": "yes" &#125;</td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingTen" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                    <h4 className="panel-title">
                                        <span>Append a record</span>
                                    </h4>
                                </div>
                                <div id="collapseTen" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTen">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>A record can be added to the uploaded file using the below data action. Following is the structure for the data action to append a record to the uploaded file.</p>
                                            </div>
                                            <div className="col">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                    <th scope="col">End Point</th>
                                                    <th scope="col">Append Record</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>Purpose</td>
                                                    <td>End point used for appending record to an uploaded file. The name of the file to which the data is to be added is given in the query parameter fileName. The data to be added is given in the request body as JSON.</td>
                                                    </tr>
                                                    <tr>
                                                    <td>URL</td>
                                                    <td> <div>protocol://hostname/record?fileName=fileName<br/>

                                                    <label className="strong">Eg: https://2kajbl04jl.execute-api.us-east-1.amazonaws.com/prod/record?fileName=File1.csv</label></div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Method</td>
                                                        <td>POST</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Required Headers</td>
                                                        <td>content-type, env, token, tokensource</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Request Body example</td>
                                                        <td>&#123; "name": "sean","title": "Esquire","fish": "yes" &#125;</td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        )
    }
}

HelpView.propTypes = {
    history: PropTypes.object
};

export default HelpView;